
    import Vue from "vue";
    import Activity from "@/models/api/activity/Activity";
    import ActivityRegistrationRequest from "@/models/api/activity/ActivityRegistrationRequest";
    import { SettingService } from "@/services/SettingService";
    import VuetifyFormMethods from "@/models/vuetify-form-methods";
    import ApplicationSettingDto from '../../models/api/ApplicationSetting';
    import { ApplicationSetting } from '../../models/Enums';
    import { ActivityService } from "@/services/ActivityService";
    import { AxiosError } from "axios";
    import { SnackbarService } from '../../services/SnackbarService';
    import DeleteDialog from '@/components/dialogs/DeleteDialog.vue';
    import { DataTableHelper } from '../../helpers/DataTableHelper';



    export default Vue.extend({
        components: {
            DeleteDialog
        },
        data() {
            return {
                pageHeader: this.$vuetify.lang.t('$vuetify.menu_activity'),
                activities: new Array<Activity>(),
                settings: new Array <ApplicationSettingDto>(),

                activityTableHeaders: [                   
                
                    { text: "name", value: "name", sortable: false },
                    { text: "", sortable: false, align: "end", value: "actions" },
                   
                ],
                isTableLoading: false,
                currentActivity: {} as Activity,
                editActivityRequest: {} as Activity,
               
                dialogOpen: false,
                editDialogOpen: false,
                registrationRequest: new ActivityRegistrationRequest("", true),
                registerActivityFormValid: false,

                showDeleteDialog: false,
                itemToDeleteId: "",
                itemToDeleteName: ""
            };
        },
        created() {
            DataTableHelper.adaptTableHeaders(this.activityTableHeaders, this);
            this.getActivities();
        },
        watch: {
            dialogOpen: {               
                handler(open: boolean) {                         
            
                    if (!open) {
                        (this.$refs.activityForm as VuetifyFormMethods).reset();
                    }
                },
            },
            editDialogOpen: {
                handler(open: boolean) {

                    if (!open) {
                        (this.$refs.editForm as VuetifyFormMethods).reset();
                    }
                },
            },
        },
        methods: {
            prepareActivityEdit(item: Activity): void {
                // Use object assign in order to separate the modified item with existing item.
                // Keeps row in datatable the same, whilst updating the values.
                Object.assign(this.editActivityRequest, item);
            },
            getApplicationSetting(app: ApplicationSetting) {
                return this.settings.findIndex((val: any) => val.keyName == app);
            },
            async registerActivity(request: ActivityRegistrationRequest) {
                ActivityService.RegisterActivity(request).then(
                    (result) => {
                        this.getActivities();
                        this.dialogOpen = false;                       
                        SnackbarService.addSuccessMessage(result?.data);
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
            async getActivity(id: number) {
                ActivityService.GetActivity(id).then(
                    (result) => {
                        this.currentActivity = result.data;
                    })
            },         
            async removeActivity(id: number) {
                this.showDeleteDialog = false;

                if (id != null) {
                    ActivityService.RemoveActivity(id).then(
                        (result) => {
                            SnackbarService.addSuccessMessage(result?.data);
                            this.getActivities();
                        },
                        (error: AxiosError) => {
                            SnackbarService.addErrorMessage(error.response?.data || error.response?.statusText
                            );
                        }
                    );
                }
            },

            async editActivity(itemToUpdate: Activity) {
                ActivityService.EditActivity(itemToUpdate).then(
                    (result) => {
                        SnackbarService.addSuccessMessage(result?.data);
                        this.getActivities();
                        this.editDialogOpen = false;
                    },
                    (error: AxiosError) => {
                        SnackbarService.addErrorMessage(
                            error.response?.data || error.response?.statusText
                        );
                    }
                );
            },
          
            //Get all activities
            async getActivities() {
                this.isTableLoading = true;
                this.activities = (await ActivityService.GetActivities()).data;
                this.isTableLoading = false;
            },

            //Rules only applied for name TODO check for name with associationId
            uniqueActivityName(value: string): string | boolean {
                if (
                    value &&
                    this.activities.findIndex(
                        (x) => x.name.trim().toLocaleLowerCase() == value.toLocaleLowerCase()
                    ) > -1
                ) {
                    return `Det finns redan en aktivitet med namnet: ${value}`;
                }
                
                return true;
            },
            uniqueActivityNameEdit(item: Activity): string | boolean {
                // Filter new name except from the item being edited.
                if (
                    item &&
                    this.activities
                        .filter((x) => x.id != item.id)
                        .findIndex(
                            (f) =>
                                f.name.trim().toLocaleLowerCase() ==
                                item.name.trim().toLocaleLowerCase()
                        ) > -1
                ) {
                    return `Det finns redan en aktivitet med namnet: ${item.name}`;
                }

                return true;
            },

        },
    })


